module.exports = __webpack_public_path__ + "static/media/Seawatergreenhouseaus_crop3_mobile.e4d27734.jpg";